<div class="modal-header">
  <h2 class="modal-title">{{product.name | translate }}</h2>
  <button type="button" class="close" (click)="closeClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body">
  <p class="text-center" style="padding:2rem 0">
    <img src="{{buildUrl(product.id)}}">
  </p>
  <p class="text-center">{{product.description | translate }}</p>
  <h3 class="product-price text-center">{{ toMoneyStr(product.price) }}</h3>
</div>
